import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, IconButton, Button, Stack, useMediaQuery, useTheme, Grow, Fade, Link } from '@mui/material';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import { getGPTAnswerForSearch } from '../../redux/actions/searchActions';
import { getGPTAnswer } from '../../redux/actions/ticketActions';
import { convertHTMLtoMarkdown } from '../../constants/utils';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import { BiLike, BiDislike } from 'react-icons/bi';
import GptSandboxDialog from './GptSandboxDialog';
import React, { useState } from 'react';
import { updateEvent } from '../../api';

const SimilarTickets = ({ similarTickets, userEmail, ticketDetails, orgId, prismToken, renderType, subDomain, ticketingSystem, agentDetails, queryText }) => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const ticketAnswerLoading = useSelector((state) => state.ticket.gptAnswerForTicketsLoading);
    const ticketAnswer = useSelector((state) => state.ticket.gptAnswerForTickets);
    const searchAnswerLoading = useSelector((state) => state.search.gptAnswerForTicketsLoading);
    const searchTicketAnswer = useSelector((state) => state.search.gptAnswerForTickets);
    const [colors, setColors] = useState({});
    const [hoveredTickets, setHoveredTickets] = useState({});
    const instanceUrl = ticketDetails?.instance_ticket_url ?? "";
    const gptAnswerForTicketsLoading = renderType === 'ticket' ? ticketAnswerLoading : searchAnswerLoading;
    const gptAnswerforTickets = renderType === 'ticket' ? ticketAnswer : searchTicketAnswer;
    const [openGptSandboxDialog, setOpenGptSandboxDialog] = useState(false);
    const handleOpenGptSandboxDialog = () => setOpenGptSandboxDialog(true);
    const handleCloseGptSandboxDialog = () => setOpenGptSandboxDialog(false);

    const handleReactionClick = (ticketId, type) => {
        const isLike = type === 'like';
        setColors(prev => ({
            ...prev,
            [ticketId]: {
                like: isLike ? (prev[ticketId]?.like === "darkgreen" ? "#a5b2bb" : "darkgreen") : "#a5b2bb",
                dislike: isLike ? "#a5b2bb" : (prev[ticketId]?.dislike === "red" ? "#a5b2bb" : "red"),
            }
        }));
        dispatch(updateEvent(`ticket${type}`, ticketId, ticketDetails?.id, ticketDetails?.subject, userEmail, orgId, prismToken));
    };

    const handleGPTClick = async () => {
        const action = renderType === "ticket" ?
            getGPTAnswer(subDomain, ticketingSystem, ticketDetails, "gptanswerfortickets", agentDetails, userEmail, prismToken, orgId, "TICKETS") :
            getGPTAnswerForSearch(subDomain, ticketingSystem, queryText, ticketDetails, "gptanswerfortickets", agentDetails, userEmail, prismToken, orgId, "TICKETS")

        await dispatch(action)
        handleOpenGptSandboxDialog(true);
    };

    if (!similarTickets.length) return null;

    return (
        <Grow in={true} timeout={500}>
            <Accordion elevation={2} sx={{ borderRadius: 2, backgroundColor: '#f9f9fb' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#152938' }} />}>
                    <Box display="flex" flexDirection="column">
                        <Typography variant="h6" fontWeight="bold" color="#152938">Similar Tickets</Typography>
                        <Typography variant="body2" color="textSecondary" fontWeight={500}>{similarTickets.length} Tickets</Typography>
                    </Box>
                </AccordionSummary>

                <AccordionDetails>
                    <Stack spacing={2}>
                        {similarTickets.map((item, index) => (
                            <Fade in={true} style={{ transitionDelay: `${index * 100}ms` }} key={index}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap={isMobile ? 'wrap' : 'nowrap'} sx={{ padding: 1.5, borderRadius: 2, backgroundColor: 'white', boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)' }}>
                                    <Box sx={{ width: isMobile ? '100%' : '75%', mb: 1 }}>
                                        <Typography variant="subtitle1" fontWeight="bold">
                                            {instanceUrl ? (
                                                <Link href={instanceUrl.replace("ticket_id", item.ticket_id)} target="_blank" rel="noopener noreferrer" underline="hover" >
                                                    #{item.ticket_id}
                                                </Link>
                                            ) : (
                                                <strong>#{item.ticket_id}</strong>
                                            )}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            <strong>Subject:</strong> {item.subject ?? "Not provided"}
                                        </Typography>
                                    </Box>

                                    <Box display="flex" gap={1}>
                                        <IconButton
                                            onClick={() => handleReactionClick(item.ticket_id, 'like')}
                                            sx={{
                                                color: hoveredTickets[`like_${item.ticket_id}`] ? 'blue' : colors[item.ticket_id]?.like || '#a5b2bb',
                                                transition: 'all 0.3s ease-in-out',
                                                transform: hoveredTickets[`like_${item.ticket_id}`] ? 'scale(1.2)' : 'scale(1)'
                                            }}
                                            onMouseEnter={() => setHoveredTickets(prev => ({ ...prev, [`like_${item.ticket_id}`]: true }))}
                                            onMouseLeave={() => setHoveredTickets(prev => ({ ...prev, [`like_${item.ticket_id}`]: false }))}
                                        >
                                            <BiLike />
                                        </IconButton>

                                        <IconButton
                                            onClick={() => handleReactionClick(item.ticket_id, 'dislike')}
                                            sx={{
                                                color: hoveredTickets[`dislike_${item.ticket_id}`] ? 'red' : colors[item.ticket_id]?.dislike || '#a5b2bb',
                                                transition: 'all 0.3s ease-in-out',
                                                transform: hoveredTickets[`dislike_${item.ticket_id}`] ? 'scale(1.2)' : 'scale(1)'
                                            }}
                                            onMouseEnter={() => setHoveredTickets(prev => ({ ...prev, [`dislike_${item.ticket_id}`]: true }))}
                                            onMouseLeave={() => setHoveredTickets(prev => ({ ...prev, [`dislike_${item.ticket_id}`]: false }))}
                                        >
                                            <BiDislike />
                                        </IconButton>
                                    </Box>
                                </Box>
                            </Fade>
                        ))}
                        <Box display="flex" justifyContent="center">
                            <Button
                                variant="contained"
                                color="inherit"
                                onClick={() => {
                                    handleGPTClick();
                                }}
                                loading={gptAnswerForTicketsLoading}
                                loadingPosition="end"
                                sx={{ textTransform: "none" }}
                                startIcon={<AutoFixHighOutlinedIcon />}
                            >
                                GPT Answer From Similar Tickets
                            </Button>
                        </Box>
                    </Stack>
                    <GptSandboxDialog open={openGptSandboxDialog} onClose={handleCloseGptSandboxDialog} renderType={renderType} content={convertHTMLtoMarkdown(gptAnswerforTickets)} loading={gptAnswerForTicketsLoading} ticketingSystem={ticketingSystem} subDomain={subDomain} userEmail={userEmail} orgId={orgId} ticketDetails={ticketDetails} prismToken={prismToken} />
                </AccordionDetails>
            </Accordion>
        </Grow>
    )
}

export default SimilarTickets